import store from '../store'
import service from '../service'

const prizes = {
  prizesActives: async () => {
    try {
      const response = await service.$http.get(`${store.API_URL}prize/active`);
      return response;
    } catch (e) {
      return e.response;
    }
  },  
}

export default prizes